import { Button, FormControlLabel, Grid, Paper, Switch, Table, TableBody, TableCell, TableContainer, TablePagination, TableRow, makeStyles, Tabs, Tab, Box, Typography } from '@material-ui/core'
import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import { ListaSolicitudesItem } from './ListaSolicitudesItem';
import { TableHeadBuscadorSolicitudes } from './TableHeadBuscadorSolicitudes';
import { MENU_AUTORIZACIONES } from '../../../utils/constants';
import { Redirect } from "react-router-dom";
import { useTraslados } from '../../../hooks/useCases/useTraslados';
import { ButtonGeneric, IconButtonGeneric } from '../../atomic/atoms/Buttons';
import { History } from '@material-ui/icons';
import IconEstado from '../UI/IconEstado';
import { GenericTable } from '../../atomic/organisms/GenericTable';
import moment from 'moment';
import { GTab } from '../../atomic/organisms/GenericTab';
import { Historial } from '../../Traslados/Bandeja/BandejaTraslados';
import { GenericModal } from '../../atomic/organisms/GenericModal';
import { ModalAuditarTraslados } from '../../Traslados/Bandeja/ModalAuditarTraslados';



const useStyles = makeStyles({
    root: {
        padding: 10,
        flexGrow: 1,
        marginTop: 20,
        // width: "100%",
    },
    input: {
        // padding: 10,
        paddingLeft: 10,
        paddingRight: 10
    },
});


function descendingComparator(a, b, orderBy) {
    if (orderBy.includes('.')) {
        const split = orderBy.split('.')
        if (split.length === 2) {
            if (!a[split[0]]) {
                return -1;
            }
            if (!b[split[0]]) {
                return 1;
            }
            if (!a[split[0]] || !b[split[0]] || b[split[0]][split[1]] < a[split[0]][split[1]]) {
                return -1;
            }
            if (b[split[0]][split[1]] > a[split[0]][split[1]]) {
                return 1;
            }
        }
    }
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === "desc"
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const initModalAuditar = {
    open: false,
    fieldsDisabled: true,
    title: ''
}
const initModalHistory = {
    open: false,
    title: ''
}

export const ListaSolicitudes = (props) => {
    const classes = useStyles();
    const { solicitudesResult } = useSelector((state) => state.autorizaciones);
    const [dense, setDense] = useState(true);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [orderBy, setOrderBy] = useState("");
    const [order, setOrder] = useState("asc");
    const [redirect, setRedirect] = useState(false);
    const [tab, setTab] = useState(1);
    const { data, get, clean } = useTraslados();
    const { idUsuario } = useSelector(state => state.auth);
    const [openModalAuditar, setOpenModalAuditar] = useState(initModalAuditar);
    const [openModalHistory, setOpenModalHistory] = useState(initModalHistory);

    /*
    const handleChangeO = (event, newValue) => {
        setTab(newValue);
    };
    */

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };

    const componentRef = React.useRef();

    const activeBreadcrumbValue = MENU_AUTORIZACIONES.BUSCADOR

    const reincio = () => {
        setRedirect(true)
    }
    console.log(tab)
    return (
        <div className={classes.root}>
            <div
                style={{
                    margin: '1rem 0',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex',
                }}
            >
                <Button variant="contained" color="primary" onClick={reincio}>
                    Reiniciar buscador
                </Button>
            </div>
            {redirect && (
                <Redirect
                    to={{
                        pathname: '/autorizaciones',
                        state: {
                            from: '/autorizaciones/',
                            activeBreadcrumb: activeBreadcrumbValue,
                        },
                    }}
                />
            )}
            {openModalHistory.open && (
                <GenericModal
                    open={openModalHistory.open}
                    closeModal={() => {
                        setOpenModalHistory(initModalHistory);
                    }}
                    title={openModalHistory.title}
                >
                    <GTab
                        tabs={data.dim.tipoTracking.map(({ id, descripcion }) => ({
                            label: descripcion,
                            component: (
                                <Historial
                                    data={data.trackingSolicitud.filter(({ idTipoTracking }) => id === idTipoTracking)}
                                />
                            )
                        }))}
                    >

                    </GTab>
                </GenericModal>
            )}

            {openModalAuditar.open && (
                <GenericModal
                    open={openModalAuditar.open}
                    closeModal={() => {
                        setOpenModalAuditar(initModalAuditar);
                        clean.solicitud();

                    }}
                    title={openModalAuditar.title}
                    gridStyle={{ textAlign: 'center', padding: '1em' }}
                    maxWidth="lg"
                >
                    <ModalAuditarTraslados
                        //estadoActual={estado}
                        fieldsDisabled={true}
                        esConsulta={true}
                        handleClose={() => {
                            setOpenModalAuditar(initModalAuditar);
                            clean.solicitud();

                        }}
                        seguimiento={true}
                    />
                </GenericModal>
            )}
            <Grid item xs={12}>
                <TableContainer component={Paper} style={{ overflowX: "auto" }}>
                    <Tabs
                        value={tab}
                        onChange={(event, newValue) => setTab(newValue)}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                        aria-label="full width tabs example"
                    >
                        <Tab label="Prácticas" value={1} {...a11yProps(1)} />
                        <Tab label="Traslados" value={2} {...a11yProps(2)} />
                    </Tabs>
                    <TabPanel value={tab} index={1}>
                        <Box display="flex" alignItems="center" mt={2}>
                            {/* Cuadradito rojo */}
                            <Box
                                width={20}
                                height={20}
                                bgcolor="#e57373"
                                borderRadius={2} // Opcional: hace esquinas redondeadas
                                marginRight={1}
                            />
                            {/* Texto */}
                            <Typography variant="body1" color="textSecondary">
                               Solicitud Anulada/Baja
                            </Typography>
                        </Box>
                        <Table size={dense ? "small" : "medium"} ref={componentRef}>
                            <TableHeadBuscadorSolicitudes
                                classes={classes}
                                {...{ order, orderBy }}
                                onRequestSort={handleRequestSort}
                            //estadoSolicitudes={estadoSolicitudes}
                            />

                            <TableBody>
                                {solicitudesResult?.results?.length > 0 ? (
                                    stableSort(solicitudesResult?.results, getComparator(order, orderBy))
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((item) => (
                                            <ListaSolicitudesItem
                                                item={item}
                                                key={item.idSolicitud?.toString()}
                                                expandirPracticas={false}
                                                reiniciarBuscador={setRedirect}
                                                {...props}
                                            />
                                        ))
                                ) : (
                                    <TableRow style={{ height: 50 }}>
                                        <TableCell
                                            colSpan={13}
                                            style={{ textAlign: "-webkit-center" }}
                                        >
                                            {" "}
                                            Sin Registros
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TabPanel>
                    <TabPanel value={tab} index={2}>
                        <GenericTable
                            data={data.solicitudes}
                            align="center"
                            columns={[
                                {
                                    label: "Historial",
                                    customBody: (item) =>
                                        <IconButtonGeneric
                                            ariaLabel="historial"
                                            Icon={History}
                                            color="primary"
                                            onClick={() => {
                                                get.getTrackingSolicitud(item.id);
                                                setOpenModalHistory({
                                                    open: true,
                                                    title: `Historial Orden N° ${item.id}`,
                                                });
                                            }}
                                        />
                                },
                                {
                                    label: "Estado",
                                    customBody: ({ idEstado }) => {
                                        const estado = data.dim.estados.find(({ id }) => id === idEstado)
                                        return (
                                            <IconEstado
                                                useColorTable
                                                texto={estado.letra}
                                                backgroundColor={estado.color}
                                                descripcion={estado.descripcion}
                                            />
                                        )
                                    }
                                },
                                {
                                    label: "Fecha",
                                    customBody: ({ fechaAlta }) => moment(fechaAlta).format("DD/MM/YYYY"),
                                    sort: true
                                },
                                {
                                    id: "id",
                                    label: "N° Orden",
                                    sort: true
                                },
                                {
                                    label: "Práctica",
                                    customBody: ({ practica }) => practica ? `${practica?.codNom} - ${practica?.desNom}` : ""
                                },
                                {
                                    label: "Diagnostico",
                                    customBody: ({ diagnostico }) => diagnostico?.problema || "No asignado"
                                },
                                {
                                    label: "Médico Tratante",
                                    customBody: ({ medico }) => medico?.apellidoNombre ? medico?.apellidoNombre.trim() : "No asignado"
                                },
                                {
                                    label: "Efector",
                                    customBody: ({ efector }) => efector?.razonSocial ? efector?.razonSocial.trim() : ""
                                },
                                {
                                    label: "Paciente",
                                    customBody: ({ afiliado }) => afiliado?.apellido_y_nombre ? afiliado.apellido_y_nombre.trim() : ""
                                },
                                {
                                    label: "N° Afiliado",
                                    customBody: ({ afiliado }) => afiliado?.carnet || ""
                                },
                                {
                                    label: "Tomada",
                                    customBody: ({ solicitudTrasladoTomada }) => solicitudTrasladoTomada?.usuarioTomada ? solicitudTrasladoTomada?.usuarioTomada?.userName : ""
                                },
                                {
                                    label: "",
                                    customBody: ({ id, solicitudTrasladoTomada }) => (
                                        <ButtonGeneric
                                            text={"Ver"}
                                            size="small"
                                            onClick={() => {
                                                get.solicitud(id, setOpenModalAuditar, idUsuario);

                                            }}
                                        />
                                    )
                                },
                                {
                                    label: "",
                                    customBody: ({ id, solicitudTrasladoTomada }) => (
                                        <ButtonGeneric
                                            text={"Eliminar"}
                                            size="small"
                                            onClick={() => {
                                                get.solicitud(id, setOpenModalAuditar, idUsuario);

                                            }}
                                        />
                                    )
                                },

                            ]}
                        />
                    </TabPanel>
                </TableContainer>
            </Grid>
            {
                solicitudesResult?.results?.length > 0 && tab === 1 && (
                    <Grid item xs={12}>
                        <TablePagination
                            style={{ backgroundColor: "white" }}
                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                            component="div"
                            count={solicitudesResult?.results?.length}
                            rowsPerPage={rowsPerPage}
                            labelRowsPerPage="Registros por página"
                            page={page}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={dense}
                                    onChange={(e) => setDense(e.target.checked)}
                                />
                            }
                            label="Tamaño compacto"
                        />
                    </Grid>

                )
            }
        </div >
    )
}
